import { ListRendererFn } from "./ListRenderer";
import styles from "../styles.module.scss";
import React from "react";
import HeroOfferView from "../componentView/HeroOfferView";
const HeroOfferRenderer: ListRendererFn = ({ list, leaveFor, page }) => {
  return (
    <HeroOfferView
      list={list}
      leaveFor={leaveFor}
      key={list.uuid}
      className={styles.hero}
      page={page}
    />
  );
};
export { HeroOfferRenderer };
